import { render, staticRenderFns } from "./drawer-shops-info.vue?vue&type=template&id=71081366&scoped=true&"
import script from "./drawer-shops-info.vue?vue&type=script&lang=js&"
export * from "./drawer-shops-info.vue?vue&type=script&lang=js&"
import style0 from "./drawer-shops-info.vue?vue&type=style&index=0&id=71081366&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71081366",
  null
  
)

export default component.exports